/**
 * Breakpoints:
 *
 * @note: Reminder of the breakpoints from sparky's _breakpoints.scss:
 * - $sparky-bp-sm: 23.4375rem; // 375px // mobile
 * - $sparky-bp-sm-2: 35rem; // 560px // mobile
 * - $sparky-bp-md: 48rem; // 768px // tablet
 * - $sparky-bp-lg: 60rem; // 960px //
 * - $sparky-bp-xl: 75rem; // 1200px // desktop
 * - $sparky-bp-xxl: 87.5rem; // 1600px // desktop
 */

export const BREAKPOINTS = {
    // mobile
    sm: 375,
    sm2: 560,
    // tablet
    md: 768,
    lg: 960,
    // desktop
    xl: 1200,
    xxl: 1600,
};
